/* Countdown for the promo bar.
   The deadline is authored in the theme editor as "YYYY-MM-DD HH:MM" and is
   read as the visitor's local time, which is what a shopper expects a sale
   clock to mean. "daily HH:MM" instead resets every day at that time in the
   section's time zone. The markup ships with the countdown hidden so a bad or past
   date never paints a row of dashes. */
(function () {
  var PAD = function (n) { return n < 10 ? '0' + n : String(n); };

  // "daily HH:MM" means a clock that ends every day at that wall-clock time in
  // the store's chosen time zone (data-tz), then rolls over to the next day.
  function tzOffset(tz, date) {
    var f = new Intl.DateTimeFormat('en-US', { timeZone: tz, hourCycle: 'h23',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit' });
    var p = {};
    f.formatToParts(date).forEach(function (x) { p[x.type] = +x.value; });
    var asUtc = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
    return { ms: asUtc - Math.floor(date.getTime() / 1000) * 1000, p: p };
  }

  function nextDaily(hh, mm, tz) {
    var now = new Date();
    var o = tzOffset(tz, now);
    var t = Date.UTC(o.p.year, o.p.month - 1, o.p.day, hh, mm, 0) - o.ms;
    if (t <= now.getTime()) t += 86400000;
    // correct for a DST change between now and the target
    t -= tzOffset(tz, new Date(t)).ms - o.ms;
    return new Date(t);
  }

  function parseEnd(value) {
    if (!value) return null;
    var v = value.trim().replace(' ', 'T');
    // A bare date means end of that day, not midnight at its start.
    if (/^\d{4}-\d{2}-\d{2}$/.test(v)) v += 'T23:59:59';
    else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(v)) v += ':00';
    var d = new Date(v);
    return isNaN(d.getTime()) ? null : d;
  }

  function init(root) {
    var raw = (root.getAttribute('data-end') || '').trim();
    var daily = raw.match(/^daily\s+(\d{1,2}):(\d{2})$/i);
    var tz = root.getAttribute('data-tz') || 'America/New_York';
    if (daily) {
      try { new Intl.DateTimeFormat('en-US', { timeZone: tz }); } catch (e) { tz = 'America/New_York'; }
    }
    var end = daily ? nextDaily(+daily[1], +daily[2], tz) : parseEnd(raw);
    var onExpire = root.getAttribute('data-on-expire') || 'hide_countdown';
    var bar = root.closest('.promo-bar');
    if (!end) return;

    var cells = {
      days: root.querySelector('[data-unit="days"]'),
      hours: root.querySelector('[data-unit="hours"]'),
      minutes: root.querySelector('[data-unit="minutes"]'),
      seconds: root.querySelector('[data-unit="seconds"]')
    };
    if (!cells.days) return;
    if (daily) {
      // a daily clock never has days left; drop that unit and its separator
      var unit = cells.days.closest('.promo-bar__unit');
      if (unit) {
        var sep = unit.nextElementSibling;
        if (sep && sep.classList.contains('promo-bar__sep')) sep.style.display = 'none';
        unit.style.display = 'none';
      }
    }

    var timer;

    function expire() {
      if (timer) clearInterval(timer);
      if (onExpire === 'hide_bar' && bar) bar.hidden = true;
      else root.style.display = 'none';
    }

    function tick() {
      var left = end.getTime() - Date.now();
      if (left <= 0) {
        if (!daily) { expire(); return; }
        end = nextDaily(+daily[1], +daily[2], tz);
        left = end.getTime() - Date.now();
      }
      var s = Math.floor(left / 1000);
      cells.days.textContent = PAD(Math.floor(s / 86400));
      cells.hours.textContent = PAD(Math.floor(s / 3600) % 24);
      cells.minutes.textContent = PAD(Math.floor(s / 60) % 60);
      cells.seconds.textContent = PAD(s % 60);
      root.hidden = false;
    }

    tick();
    if (!root.hidden) timer = setInterval(tick, 1000);
  }

  function boot() {
    document.querySelectorAll('.promo-bar__countdown').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // The theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', boot);
})();
